import { render, staticRenderFns } from "./RatingShineIcon.vue?vue&type=template&id=456b9b7a"
import script from "./RatingShineIcon.vue?vue&type=script&lang=js"
export * from "./RatingShineIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports